/**
 * The last line: a rendering bug should cost one screen, not the whole app.
 *
 * Without this, any thrown error in a component unmounts the entire React tree
 * and leaves a blank white page - which looks, to a user, exactly like the
 * server being down. The message here is deliberately generic and in Turkish;
 * the actual error goes to the console.
 */

import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  failed: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[sentyform] arayüz hatası", error, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="card stack" style={{ margin: "var(--sp-6) auto", maxWidth: "36rem" }}>
        <h2>Arayüzde beklenmeyen bir hata oluştu</h2>
        <p className="muted">
          Bu ekran çizilirken bir sorun çıktı. Sayfayı yenilemek genellikle yeterlidir.
          Sorun sürerse teknik ayrıntılar tarayıcı konsolunda yer alır.
        </p>
        <div>
          <button className="btn btn--primary" type="button" onClick={() => window.location.reload()}>
            Sayfayı yenile
          </button>
        </div>
      </div>
    );
  }
}
